import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {TreeNode} from "primeng/api";
import {mapPaymentReceivedTree, PaymentReceivedNodeDto} from "../../../model/dto/entity/payment-received-node.dto";

// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'bm-payment-received-trace',
    templateUrl: 'bm-payment-received-trace.component.html',
    standalone: false
})
export class BmPaymentReceivedTraceComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    paymentReceivedNodeDto: PaymentReceivedNodeDto;

    chartData: TreeNode[];

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
        this.prepareTestData();
        if (this.paymentReceivedNodeDto) {
            this.chartData = mapPaymentReceivedTree([this.paymentReceivedNodeDto]);
            this.initialized = true;
        }
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
    prepareTestData(){
        this.paymentReceivedNodeDto =
            {
            data: {
                id: 1,
                name: 'Payment Received',
                paymentBankAccountDtoId: 101,
                // paymentBankAccountDtoName: 'Bank Account XYZ',
                // valueDate: new Date('2025-05-03'),
                // bookingDate: new Date('2025-05-03'),
                // amount: 30,
                // currency: 'EUR',
                // reference: 'PR-20250503',
                // statementId: 'STM001',
                // statementCreationDateTime: new Date(),
                // entryReference: 'EREF001',
                // accountServiceReference: 'ASREF001',
                // credit: true,
                // debtorName: 'Sender Company',
                // debtorIban: 'DE1234567890',
                // creditorName: 'Our Company',
                // creditorIban: 'NL0987654321',
                // localInstrument: 'Manual'
            },
            main: true,
            children: [
                {
                    data: {
                        id: 2,
                        name: 'Customer Allocation',
                        customerDtoId: 201,
                        // customerDtoName: 'Amos Balasek',
                        // paymentReceivedDtoId: 1,
                        // paymentReceivedDtoName: 'PR-20250503',
                        // allocatedAmount: 30,
                        // currency: 'EUR',
                        // allocationTypeInternal: PaymentAllocationTypeInternal.CREDIT,
                        // plannedPaymentDtoId: 3,
                        // plannedPaymentDtoName: 'May 2025',
                    },
                    main: true,
                    children: [
                        {
                            data: {
                                id: 3,
                                name: 'Customer Payment Plan',
                                billingRunDtoId: 301,
                                // billingRunDtoName: 'Billing Run May 2025',
                                // customerDtoId: 201,
                                // customerDtoName: 'Amos Balasek',
                                // plannedTypeDtoId: 401,
                                // plannedTypeDtoName: 'Regular Payment',
                                // paymentStatus: PlannedPaymentStatus.PAID,
                                // amount: 30,
                                // remainingAmount: 0,
                                // currency: 'EUR',
                            },
                            main: true,
                            children: [
                                {
                                    data: {
                                        id: 4,
                                        name: 'Contract Payment Allocation Detail A', // Example name
                                        contractDtoId: 501,
                                        // contractDtoName: 'Contract A',
                                        // plannedPaymentDtoId: 6,
                                        // plannedPaymentDtoName: 'Contract Payment Plan A',
                                        // customerPaymentAllocationDtoId: 2,
                                        // customerPaymentAllocationDtoName: 'Amos Balasek Allocation',
                                        // allocatedAmount: 10,
                                        // currency: 'EUR',
                                        // allocationTypeInternal: 'Manual' as any, // Example allocation type
                                    },
                                    main: true,
                                    children: [
                                        {
                                            data: {
                                                id: 6,
                                                name: 'Contract Payment Planned Detail A', // Example name
                                                contractDtoId: 501,
                                                // contractDtoName: 'Contract A',
                                                // startDate: new Date('2025-05-01'),
                                                // endDate: new Date('2025-05-31'),
                                                // dueDate: new Date('2025-05-15'),
                                                // plannedTypeDtoId: 701,
                                                // plannedTypeDtoName: 'Monthly Fee',
                                                // status: 'Paid' as any, // Assuming 'Paid' is a valid PlannedPaymentStatus
                                                // amount: 10,
                                                // remainingAmount: 0,
                                                // currency: 'EUR',
                                            },
                                            main: true,
                                            children: [
                                                {
                                                    data: {
                                                        id: 501,
                                                        name: 'Contract Detail A', // Example name
                                                        categoryDtoId: 801,
                                                        categoryDtoName: 'Insurance',
                                                        // groupDtoId: 901,
                                                        // groupDtoName: 'Group Alpha',
                                                        // baseTypeDtoId: 1001,
                                                        // contractTypeDtoId: 1101,
                                                        // contractTypeDtoName: 'Car Insurance',
                                                        // productDtoId: 1201,
                                                        // productDtoName: 'Standard Car Policy',
                                                        // entityStatus: 'Active' as any, // Assuming 'Active' is a valid EntityStatusEnum
                                                        // contractIdentifier: 'CA001',
                                                        // alias: 'Car Policy A',
                                                        // startDate: new Date('2025-01-01'),
                                                        // endDate: new Date('2025-12-31'),
                                                        // plannedEndDate: new Date('2025-12-31'),
                                                        // comment: 'Annual car insurance policy',
                                                        // formerContractDtoId: null,
                                                        // baseStatus: 'Active' as any, // Assuming 'Active' is a valid ContractBaseStatusEnum
                                                        // baseStatusEnumName: 'Active',
                                                        // baseStatusEnumImage: '',
                                                        // baseStatusEnumColor: '',
                                                        // baseStatusEnumColorBackground: '',
                                                    },
                                                    main: false,
                                                    children: [],
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    data: {
                                        id: 5,
                                        name: 'Contract Payment Allocation Detail B', // Example name
                                        contractDtoId: 502,
                                        contractDtoName: 'Contract B',
                                        // plannedPaymentDtoId: 7,
                                        // plannedPaymentDtoName: 'Contract Payment Plan B',
                                        // customerPaymentAllocationDtoId: 2,
                                        // customerPaymentAllocationDtoName: 'Amos Balasek Allocation',
                                        // allocatedAmount: 10,
                                        // currency: 'EUR',
                                        // allocationTypeInternal: 'Manual' as any, // Example allocation type
                                    },
                                    main: true,
                                    children: [
                                        {
                                            data: {
                                                id: 7,
                                                name: 'Contract Payment Planned Detail B', // Example name
                                                contractDtoId: 502,
                                                contractDtoName: 'Contract B',
                                                // startDate: new Date('2025-05-01'),
                                                // endDate: new Date('2025-05-31'),
                                                // dueDate: new Date('2025-05-15'),
                                                // plannedTypeDtoId: 702,
                                                // plannedTypeDtoName: 'Monthly Fee',
                                                // status: 'Paid' as any, // Assuming 'Paid' is a valid PlannedPaymentStatus
                                                // amount: 10,
                                                // remainingAmount: 0,
                                                // currency: 'EUR',
                                            },
                                            main: true,
                                            children: [
                                                {
                                                    data: {
                                                        id: 502,
                                                        name: 'Contract Detail B', // Example name
                                                        categoryDtoId: 802,
                                                        categoryDtoName: 'Insurance',
                                                        // groupDtoId: 902,
                                                        // groupDtoName: 'Group Beta',
                                                        // baseTypeDtoId: 1002,
                                                        // contractTypeDtoId: 1102,
                                                        // contractTypeDtoName: 'Travel Insurance',
                                                        // productDtoId: 1202,
                                                        // productDtoName: 'Standard Travel Policy',
                                                        // entityStatus: 'Active' as any, // Assuming 'Active' is a valid EntityStatusEnum
                                                        // contractIdentifier: 'TB002',
                                                        // alias: 'Travel Policy B',
                                                        // startDate: new Date('2025-03-01'),
                                                        // endDate: new Date('2025-08-31'),
                                                        // plannedEndDate: new Date('2025-08-31'),
                                                        // comment: 'Travel insurance policy',
                                                        // formerContractDtoId: null,
                                                        // baseStatus: 'Active' as any, // Assuming 'Active' is a valid ContractBaseStatusEnum
                                                        // baseStatusEnumName: 'Active',
                                                        // baseStatusEnumImage: '',
                                                        // baseStatusEnumColor: '',
                                                        // baseStatusEnumColorBackground: '',
                                                    },
                                                    main: false,
                                                    children: []
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    data: {
                                        id: 8,
                                        name: 'Contract Payment Allocation Detail C', // Example name
                                        contractDtoId: 503,
                                        // contractDtoName: 'Contract C',
                                        // plannedPaymentDtoId: 9,
                                        // plannedPaymentDtoName: 'Contract Payment Plan C',
                                        // customerPaymentAllocationDtoId: 2,
                                        // customerPaymentAllocationDtoName: 'Amos Balasek Allocation',
                                        // allocatedAmount: 10,
                                        // currency: 'EUR',
                                        // allocationTypeInternal: 'Manual' as any, // Example allocation type
                                    },
                                    main: true,
                                    children: [
                                        {
                                            data: {
                                                id: 9,
                                                name: 'Contract Payment Planned Detail C', // Example name
                                                contractDtoId: 503,
                                                contractDtoName: 'Contract C',
                                                // startDate: new Date('2025-05-01'),
                                                // endDate: new Date('2025-05-31'),
                                                // dueDate: new Date('2025-05-15'),
                                                // plannedTypeDtoId: 703,
                                                // plannedTypeDtoName: 'Monthly Fee',
                                                // status: PlannedPaymentStatus.PAID, // Assuming 'Paid' is a valid PlannedPaymentStatus
                                                // amount: 10,
                                                // remainingAmount: 0,
                                                // currency: 'EUR',
                                            },
                                            main: true,
                                            children: [
                                                {
                                                    data: {
                                                        id: 503,
                                                        name: 'Contract Detail C', // Example name
                                                        categoryDtoId: 803,
                                                        categoryDtoName: 'Insurance',
                                                        // groupDtoId: 903,
                                                        // groupDtoName: 'Group Gamma',
                                                        // baseTypeDtoId: 1003,
                                                        // contractTypeDtoId: 1103,
                                                        // contractTypeDtoName: 'Legal Insurance',
                                                        // productDtoId: 1203,
                                                        // productDtoName: 'Standard Legal Policy',
                                                        // entityStatus: 'Active' as any, // Assuming 'Active' is a valid EntityStatusEnum
                                                        // contractIdentifier: 'LC003',
                                                        // alias: 'Legal Policy C',
                                                        // startDate: new Date('2025-04-01'),
                                                        // endDate: new Date('2025-09-30'),
                                                        // plannedEndDate: new Date('2025-09-30'),
                                                        // comment: 'Legal insurance policy',
                                                        // formerContractDtoId: null,
                                                        // baseStatus: 'Active' as any, // Assuming 'Active' is a valid ContractBaseStatusEnum
                                                        // baseStatusEnumName: 'Active',
                                                        // baseStatusEnumImage: '',
                                                        // baseStatusEnumColor: '',
                                                        // baseStatusEnumColorBackground: '',
                                                    },
                                                    main: false,
                                                    children: []
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    }

}
